module.exports = __webpack_public_path__ + "img/mom_and_girl_small.8929beda.png";